import React from 'react';
import { Heart, TrendingUp, Zap } from 'lucide-react';
import imghero from "../images/HeroPageImg.png";

export default function About() {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="relative py-20 pt-32 bg-gradient-to-br from-indigo-50 via-background to-emerald-50 heroimg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 animate-slideUp">
            About Sarayu
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto animate-slideUp" style={{ animationDelay: '0.1s' }}>
            Reimagining travel through the power of AI and emotional intelligence.
          </p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-white bgsecimg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="animate-slideUp">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Guardian + Storyteller</h2>
              <p className="text-lg text-gray-600 mb-6">
                Sarayu is built on a simple belief: travel should be about joy, not stress. We combine the protective instincts of a guardian with the creative spirit of a storyteller.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Our AI doesn't just navigate you from point A to point B. It anticipates your needs, protects your safety, captures your moments, and helps you share your story with the world.
              </p>
              <p className="text-lg text-gray-600">
                We're not building another navigation app. We're building your travel companion.
              </p>
            </div>

            <div className="glass rounded-3xl p-12 h-96 flex items-center justify-center animate-slideUp" style={{ animationDelay: '0.1s' }}>
              <div className="text-center">
                {/* <div className="text-8xl mb-4">🌍</div>
                <p className="text-gray-700 font-semibold">Your Global Companion</p> */}
                <img src={imghero} alt="Hero Image" className="w-full h-full object-cover rounded-3xl" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Insight Section */}
      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Market Insight</h2>
            <p className="text-xl text-gray-600">
              Emotion-driven travel is the future.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass rounded-2xl p-8 text-center card-hover">
              <Heart className="w-12 h-12 text-red-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Emotional Connection</h3>
              <p className="text-gray-600">
                Travelers don't just want to reach destinations. They want to feel alive, connected, and present.
              </p>
            </div>

            <div className="glass rounded-2xl p-8 text-center card-hover">
              <TrendingUp className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Growing Market</h3>
              <p className="text-gray-600">
                The travel tech market is expanding rapidly, with consumers seeking smarter, more personalized solutions.
              </p>
            </div>

            <div className="glass rounded-2xl p-8 text-center card-hover">
              <Zap className="w-12 h-12 text-indigo-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-3">AI Revolution</h3>
              <p className="text-gray-600">
                Generative AI enables us to create experiences that were impossible just a year ago.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Edge Section */}
      <section className="py-20 bg-white bgsecimg1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Edge</h2>
            <p className="text-xl text-gray-600">
              Emotional currency vs navigation tools.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="glass rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Traditional Navigation Apps</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <span className="text-gray-400">✗</span>
                  <span className="text-gray-600">Focus on routes, not experiences</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-gray-400">✗</span>
                  <span className="text-gray-600">Reactive, not proactive</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-gray-400">✗</span>
                  <span className="text-gray-600">Fragmented tools and data</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-gray-400">✗</span>
                  <span className="text-gray-600">No memory preservation</span>
                </li>
              </ul>
            </div>

            <div className="glass rounded-2xl p-8 border-2 border-emerald-500">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Sarayu</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <span className="text-emerald-600">✓</span>
                  <span className="text-gray-600">Emotional intelligence at the core</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-emerald-600">✓</span>
                  <span className="text-gray-600">Predictive and protective</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-emerald-600">✓</span>
                  <span className="text-gray-600">Unified, intelligent platform</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-emerald-600">✓</span>
                  <span className="text-gray-600">Automatic storytelling & sharing</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Roadmap</h2>
            <p className="text-xl text-gray-600">
              Building the future of travel, one milestone at a time.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* 2025 - The Guardian */}
            <div className="glass rounded-2xl p-8 card-hover border-2 border-indigo-500">
              <div className="inline-block bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full font-bold mb-4">
                2025
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">The Guardian</h3>
              <ul className="space-y-3 text-gray-600">
                <li>✓ Core AI routing and real-time alerts</li>
                <li>✓ AI-powered trip planning</li>
                <li>✓ Proactive guidance system</li>
                <li>✓ Personalized recommendations</li>
              </ul>
            </div>

            {/* Q1 2026 - The Storyteller */}
            <div className="glass rounded-2xl p-8 card-hover border-2 border-emerald-500">
              <div className="inline-block bg-emerald-100 text-emerald-600 px-4 py-2 rounded-full font-bold mb-4">
                Q1 2026
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">The Storyteller</h3>
              <ul className="space-y-3 text-gray-600">
                <li>✓ Integrating GenAI Scrapbook</li>
                <li>✓ Automatic photo curation</li>
                <li>✓ Generative AI storytelling</li>
                <li>✓ Digital scrapbooks</li>
              </ul>
            </div>

            {/* Q2 2026 - The Platform */}
            <div className="glass rounded-2xl p-8 card-hover border-2 border-pink-500">
              <div className="inline-block bg-pink-100 text-pink-600 px-4 py-2 rounded-full font-bold mb-4">
                Q2 2026
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">The Platform</h3>
              <ul className="space-y-3 text-gray-600">
                <li>✓ Monetizing premium features</li>
                <li>✓ Launching API for EV manufacturers</li>
                <li>✓ Targeting 100,000 monthly active users</li>
                <li>✓ Group travel features</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-20 bg-gradient-to-r from-indigo-600 to-emerald-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Be Part of the Journey
          </h2>
          <p className="text-xl text-black/90 mb-8">
            We're building something special. Join us as we revolutionize travel.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-white text-indigo-600 font-bold rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
          >
            Get in Touch
          </a>
        </div>
      </section> */}
    </div>
  );
}
